import {
  CommonSharedByType,
  mapCommonSharedByType,
} from "../../../Share/CommonSharedByType";
import { AttendanceData, mapAttendanceDatas } from "./AttendanceData";

/* ******************************************************* Attendance day view */
export interface AttendanceDayView {
  project_id?: number;
  site_address?: string;
  full_address?: string;
  data_count?: number;
  data?: AttendanceData[];
  is_own_project: boolean;
  shared_by?: CommonSharedByType | null;
}

export const mapAttendanceDayView = (dayData: any): AttendanceDayView => {
  if (!dayData) {
    throw new Error("Invalid Data");
  }

  const response: AttendanceDayView = {
    project_id: dayData.project_id,
    site_address: dayData.site_address,
    full_address: dayData.full_address,
    data_count: dayData.data_count,
    data: Array.isArray(dayData.data) ? mapAttendanceDatas(dayData.data) : [],
    is_own_project: dayData.is_own_project,
    shared_by: dayData.shared_by
      ? mapCommonSharedByType(dayData.shared_by)
      : null,
  };

  return response;
};

export const mapAttendanceDayViews = (data: any[]): AttendanceDayView[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapAttendanceDayView);
};
/* ******************************************************* */
